import React from 'react';
import { SlideTitle } from '../../../../../styles/LearnTab/slideBase.styles';

export const isSameAsTitle = (text, slide) => {
  if (!text || !slide) return false;
  const origin = slide._pbdq_origin || slide;
  const title = slide.SlideTitle || origin.headline || origin.title || '';
  const norm = (s) => (s || '').trim().toLowerCase().replace(/[.:!?]+$/, '');
  return !!text && norm(text) === norm(title);
};

export const SlideTitleHeader = ({
  slide,
  title,
  slideEdits = {},
  showEnglishContent = false,
  highlightWord,
  style = {},
  TitleComponent = SlideTitle,
  ...props
}) => {
  if (!slide && !title) return null;

  const origin = slide?._pbdq_origin || slide || {};
  const rawTitle = title !== undefined ? title : (slide?.SlideTitle || origin.headline || origin.title || '');
  if (!rawTitle || !String(rawTitle).trim()) return null;

  const titleEdit = slideEdits?.['title'];
  const displayTitle = showEnglishContent ? (titleEdit?.original || rawTitle) : (titleEdit?.edited || rawTitle);
  const hasHtmlTags = /<[^>]+>/.test(displayTitle);

  return (
    <TitleComponent style={style} {...props}>
      {hasHtmlTags ? (
        <span dangerouslySetInnerHTML={{ __html: displayTitle }} />
      ) : (
        highlightWord ? highlightWord('title', displayTitle) : displayTitle
      )}
    </TitleComponent>
  );
};

export default SlideTitleHeader;
